import type { ReactNode } from 'react'
import { BarChart3, KeyRound, TableProperties } from 'lucide-react'
import { NavLink } from 'react-router'

const keywordViews = [
  {
    path: '/producttype-keywords/analysis',
    label: 'Keyword-Analyse',
    icon: KeyRound,
  },
  {
    path: '/producttype-keywords/coverage',
    label: 'Keyword-Abdeckung',
    icon: TableProperties,
  },
  {
    path: '/producttype-keywords/traffic',
    label: 'Keyword-Traffic',
    icon: BarChart3,
  },
] as const

export function KeywordAreaNav(): ReactNode {
  return (
    <div className="mb-6 rounded-2xl border border-slate-200 bg-white p-3 shadow-sm dark:border-slate-700 dark:bg-slate-900">
      <p className="mb-2 px-2 text-xs font-black uppercase tracking-[0.14em] text-slate-500 dark:text-slate-400">
        Produkttyp-Keywords
      </p>
      <nav aria-label="Produkttyp-Keywords" className="flex flex-wrap gap-2">
        {keywordViews.map((view) => {
          const Icon = view.icon

          return (
            <NavLink
              key={view.path}
              to={view.path}
              className={({ isActive }) =>
                isActive
                  ? 'inline-flex items-center gap-2 rounded-xl bg-blue-600 px-4 py-2.5 text-sm font-bold text-white shadow-sm dark:bg-blue-500'
                  : 'inline-flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-600 transition hover:bg-slate-100 hover:text-slate-950 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-white'
              }
            >
              <Icon aria-hidden="true" size={16} />
              {view.label}
            </NavLink>
          )
        })}
      </nav>

      <div className="mt-3 flex flex-wrap gap-2 border-t border-slate-200 pt-3 dark:border-slate-700">
        {['Motiv-Keywords'].map((label) => (
          <button
            key={label}
            type="button"
            disabled
            className="inline-flex cursor-not-allowed items-center gap-2 rounded-xl border border-dashed border-slate-300 bg-slate-100 px-4 py-2.5 text-sm font-semibold text-slate-400 dark:border-slate-700 dark:bg-slate-800/60 dark:text-slate-500"
          >
            {label}
            <span className="rounded-full bg-slate-200 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-slate-500 dark:bg-slate-700 dark:text-slate-400">
              Kommt noch
            </span>
          </button>
        ))}
        <NavLink
          to="/collection-keywords/analysis"
          className="inline-flex items-center gap-2 rounded-xl border border-fuchsia-200 bg-fuchsia-50 px-4 py-2.5 text-sm font-semibold text-fuchsia-700 hover:bg-fuchsia-100 dark:border-fuchsia-900 dark:bg-fuchsia-950/40 dark:text-fuchsia-300"
        >
          Collection-Keywords
          <span className="rounded-full bg-fuchsia-100 px-2 py-0.5 text-[10px] font-bold uppercase dark:bg-fuchsia-900">
            Aktiv
          </span>
        </NavLink>
      </div>
    </div>
  )
}
